import React from 'react';

const InfoMessagePaymentProcessing = ({ children }) => (
  <div className="alert alert-info">
    { children }
  </div>
);

export default InfoMessagePaymentProcessing;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/info-message.js